import { Permission, PermissionEntitiesNames } from '@fabric-ui/components';
import { createFileRoute } from '@tanstack/react-router';
import { APP_PATHS, PAGE_PATHS } from '../../../../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}/audit/')({
  beforeLoad: ({ context, preload }) => {
    const { hasAllowedPermission, hasAllowedPermissionToResource } = context.userPermissions;
    const path = PAGE_PATHS.RULE_SET;
    const app = APP_PATHS.ASSETS;
    const permissionObject = { app, path };
    const isAllowed =
      hasAllowedPermission(permissionObject) &&
      hasAllowedPermissionToResource({ resource: PermissionEntitiesNames.ACCOUNT, permission: Permission.UPDATE });
    context.validatePermissions({ isAllowed, preload });
  },
});
